import React from "react";
 
interface ButtonProps {
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
  className?: string;
  color?: string;
  fullWidth?: boolean; // New prop for controlling width
}
export default function Button({
  onClick,
  type = "button",
  disabled = false,
  loading = false,
  children,
  className,
  color = "#1d4ed8",
  fullWidth = false, // Default to content-based width
  ...rest
}: ButtonProps) {
  const isButtonDisabled = disabled || loading;
  
  return (
    <>
      <button
        type={type}
        onClick={onClick}
        disabled={isButtonDisabled}
        className={`${fullWidth ? "w-full" : ""} text-white bg-${color}-600 hover:bg-${color}-700 focus:ring-1 focus:outline-none focus:ring-${color}-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-${color}-600 dark:hover:bg-${color}-700 dark:focus:ring-${color}-800 ${
          isButtonDisabled ? "cursor-not-allowed opacity-50" : `hover:bg-${color}-700`
        } ${className} flex items-center justify-center gap-2`}
        {...rest}
      >
        {loading && (
          <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        )}
        {children}
      </button>
    </>
  );
}
